// get all po's
export const GET_PURCHASE_ORDERS_REQUEST = 'GET_PURCHASE_ORDERS_REQUEST';
export const GET_PURCHASE_ORDERS_SUCCESS = 'GET_PURCHASE_ORDERS_SUCCESS';
export const GET_PURCHASE_ORDERS_FAIL = 'GET_PURCHASE_ORDERS_FAIL';

// create po
export const CREATE_PURCHASE_ORDERS_REQUEST = 'CREATE_PURCHASE_ORDERS_REQUEST';
export const CREATE_PURCHASE_ORDERS_SUCCESS = 'CREATE_PURCHASE_ORDERS_SUCCESS';
export const CREATE_PURCHASE_ORDERS_FAIL = 'CREATE_PURCHASE_ORDERS_FAIL';

// clear created purchase state data
export const CLEAR_CREATED_PURCHASE_STATE = 'CLEAR_CREATED_PURCHASE_STATE';

// update single po
export const UPDATE_PURCHASE_ORDER_REQUEST = 'UPDATE_PURCHASE_ORDER_REQUEST';
export const UPDATE_PURCHASE_ORDER_SUCCESS = 'UPDATE_PURCHASE_ORDER_SUCCESS';
export const UPDATE_PURCHASE_ORDER_FAIL = 'UPDATE_PURCHASE_ORDER_FAIL';

// get po items
export const GET_PURCHASE_ORDER_ITEMS_REQUEST =
  'GET_PURCHASE_ORDER_ITEMS_REQUEST';
export const GET_PURCHASE_ORDER_ITEMS_SUCCESS =
  'GET_PURCHASE_ORDER_ITEMS_SUCCESS';
export const GET_PURCHASE_ORDER_ITEMS_FAIL = 'GET_PURCHASE_ORDER_ITEMS_FAIL';
export const CLEAR_GET_PURCHASE_ORDER_ITEMS_STATES =
  'CLEAR_GET_PURCHASE_ORDER_ITEMS_STATES';

// search repair orders
export const SEARCH_REPAIR_ORDERS_REQUEST = 'SEARCH_REPAIR_ORDERS_REQUEST';
export const SEARCH_REPAIR_ORDERS_SUCCESS = 'SEARCH_REPAIR_ORDERS_SUCCESS';
export const SEARCH_REPAIR_ORDERS_FAIL = 'SEARCH_REPAIR_ORDERS_FAIL';
export const CLEAR_SEARCH_REPAIR_ORDERS_STATES =
  'CLEAR_SEARCH_REPAIR_ORDERS_STATES';

// get parts and supply by single ro
export const GET_PARTS_SUPPLY_BY_RO_REQUEST = 'GET_PARTS_SUPPLY_BY_RO_REQUEST';
export const GET_PARTS_SUPPLY_BY_RO_SUCCESS = 'GET_PARTS_SUPPLY_BY_RO_SUCCESS';
export const GET_PARTS_SUPPLY_BY_RO_FAIL = 'GET_PARTS_SUPPLY_BY_RO_FAIL';
export const CLEAR_PARTS_SUPPLY_BY_RO_STATES =
  'CLEAR_PARTS_SUPPLY_BY_RO_STATES';
